
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Pourquoi communiquer quand on est une entreprise ?",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez comment maitriser la communication professionnelle pour booster votre activité et augmenter vos revenus grâce à des stratégies claires et efficaces.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Pourquoi communiquer quand on est une entreprise ?",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "La communication est devenue une clé à maîtriser dans les moindres détails. Parmi eux : le biais digital. Toutefois, en tant que professionnel, il n’est pas aisé de savoir comment communiquer de manière efficace et pertinente afin de donner un gros coup d’accélérateur à votre activité et vos revenus.",
        },
      ],
    };
  },
};
